import { c as _c } from "react/compiler-runtime";
import { CountryFlag } from "@connect/component-library/components/country-flag";
export const CountryRow = t0 => {
  const $ = _c(17);
  const {
    code,
    name,
    selected,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== code || $[1] !== onSelect) {
    t1 = () => onSelect(code);
    $[0] = code;
    $[1] = onSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== code) {
    t2 = <CountryFlag code={code} />;
    $[3] = code;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name) {
    t3 = <span className="flex-1 text-surface-foreground">{name}</span>;
    $[5] = name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = selected ? "flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-surface-foreground" : "h-5 w-5 shrink-0 rounded-full border-2 border-surface-weak";
  let t5;
  if ($[7] !== selected) {
    t5 = selected && <span className="h-2.5 w-2.5 rounded-full bg-surface-foreground" />;
    $[7] = selected;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t6) {
    t7 = <button type="button" className="flex w-full items-center gap-3 py-3 text-left" onClick={t1}>{t2}{t3}{t6}</button>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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